import React from "react";
import { createPortal } from "react-dom";

import { PopupType, usePopup } from "../../../Context/PopupContext";
import DeleteVideoCommentDialog from "./DeleteVideoCommentDialog";

export interface DeleteVideoCommentPopupData {
    commentId: number;
    requiresReason: boolean;
    onDelete: (reason?: string) => Promise<unknown>;
    onFocusChange?: (focused: boolean) => void;
}

const DeleteVideoCommentPopup: React.FC = () => {
    const { activePopup, popupData, closePopup } = usePopup();

    if (
        activePopup !== PopupType.COMMENT_DELETE ||
        !popupData ||
        typeof document === "undefined"
    ) {
        return null;
    }

    const data = popupData as DeleteVideoCommentPopupData;

    return createPortal(
        <DeleteVideoCommentDialog
            key={data.commentId}
            requiresReason={data.requiresReason}
            onClose={closePopup}
            onDelete={data.onDelete}
            onFocusChange={data.onFocusChange}
        />,
        document.body
    );
};

export default DeleteVideoCommentPopup;
